import { useTranslation } from 'react-i18next';

import { MODULE_SELECT_ARIA_KEY } from './ModuleSelect.constants';
import type { ModuleSelectProps } from './ModuleSelect.types';

export const ModuleSelect = ({ modules, value, onChange }: ModuleSelectProps) => {
	const { t } = useTranslation('translation', { keyPrefix: 'sidebar' });
	// Keep the current value visible while the modules list loads.
	const options = modules.length > 0 ? modules : [value];

	return (
		<select
			value={value}
			onChange={(e) => onChange(e.target.value)}
			aria-label={t(MODULE_SELECT_ARIA_KEY)}
			className="w-full rounded-md border border-subtle bg-white px-xs py-3xs text-[12px] text-default transition-colors hover:border-default focus:border-action-primary focus:outline-none focus:ring-2 focus:ring-action-primary/15"
		>
			{options.map((name) => (
				<option key={name} value={name}>
					{name}
				</option>
			))}
		</select>
	);
};
